import React , { useEffect, useState} from 'react';
import { Row, Col, Select } from 'antd';
import '../styles/vehicle-management.style.scss';
import { AgentsTableComponent } from '../components/agents-component/agent-table.component';
import { useSelector, useDispatch} from 'react-redux';
import {agentsSelector, agentPrivilegesSelector} from '../selector/agents.selector';
import { AgentForm } from '../components/agents-component/agents-form.component';
import { getAgents, getAgentPrivileges } from '../actions/agents.actions';
import { getActiveOperators } from '../actions/admin.action';
import { activeOperatorsSelector } from '../selector/admin.selector';
import { isValid, isValidArray } from '../utils/utilities';
import { getBranchOffices } from '../actions/address.actions';
import { dafidyUserCheck } from '../utils/constant';

const { Option } = Select;

export const AgentsUserPage = (props) => {

    const dispatch = useDispatch();

    const isDafidyUser = dafidyUserCheck();

    const agentsReducer = useSelector(agentsSelector);
    const agentPrivilegesReducer = useSelector(agentPrivilegesSelector);
    const { activeOperators } = useSelector(activeOperatorsSelector);
    const [formData,updateformData] = useState({});
    const [branchOffices,setBranchOffices] = useState([]);
    const [selectedOperatorCode, setSelectedOperatorCode] = useState(null);

    useEffect(()=>{
        if(isDafidyUser){
            dispatch(getActiveOperators());
        } else {
            dispatch(getAgents(false,false,()=>{},()=>{},undefined,true));
            dispatch(getAgentPrivileges());
            getBranchOffices(setBranchOffices);
        }
    },[])

    const onChangeOperator = (operatorCode) =>{
        setSelectedOperatorCode(operatorCode);
        updateformData({});
        if(isValid(operatorCode)){
            dispatch(getAgents(false,false,()=>{},()=>{},operatorCode,true));
            dispatch(getAgentPrivileges());
            getBranchOffices(setBranchOffices);
        }
    }

    return (
        <div className="vehicle-management-root">
                {isDafidyUser &&
                    <Row className="agents-user-operator-select-row" gutter={[16,16]} style={{padding: '10px 0'}}>
                        <Col>
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select a travel"
                                style={{minWidth: 240}}
                                value={selectedOperatorCode}
                                onChange={onChangeOperator}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '').toLowerCase().includes((input || '').toLowerCase())
                                }
                            >
                                {isValidArray(activeOperators) && activeOperators.map((operator)=>(
                                    <Option value={operator.operator_code} key={operator.operator_code}>
                                        {operator.name}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                }
                {isValidArray(agentsReducer)&&
                    <AgentsTableComponent
                    agents={agentsReducer}
                    formData={formData}
                    updateformData={updateformData}
                    />
                }
                {isValidArray(agentPrivilegesReducer)&&
                    <AgentForm
                        agentPrivilieges={agentPrivilegesReducer}
                        formData={formData}
                        updateformData={updateformData}
                        branchOffices={branchOffices}
                        selectedOperatorCode={selectedOperatorCode}
                        agents={agentsReducer}
                    />
                }
        </div>
    );
}
